import type { WorkshopChip } from './workshopsCalendarTypes';

/** Same blue as the "Disabled" pill on the workshop page. */
export const DISABLED_COLOR = 'var(--nb-info)';
export const DISABLED_LABEL = 'Sales disabled';

/** A disabled workshop still runs; it has only stopped taking new bookings. */
export function isDisabled(w: Pick<WorkshopChip, 'lifecycle'>): boolean {
  return w.lifecycle === 'disabled';
}
